//@ts-nocheck

interface LineSpinnerProps {
    size?: string;
    speed?: string;
    color?: string;
    stroke?: string;
}
const NewtonsCradleLoading = (props: LineSpinnerProps) => {
    const { size = '20', speed = '4', color, stroke = '3' } = props;

    return (
        <l-newtons-cradle
            size={size}
            stroke={stroke}
            speed={speed}
            color={color}></l-newtons-cradle>
    );
};

export default NewtonsCradleLoading;
